const DASHBOARD = 'Dashboard';
/** Dashboard Widget actions (Add) */
export const ADD_WIDGET = `${DASHBOARD}/ADD_WIDGET`;
export const ADD_WIDGET_RESPONSE = `${DASHBOARD}/ADD_WIDGET_RESPONSE`;
export const ADD_WIDGET_ERROR = `${DASHBOARD}/ADD_WIDGET_ERROR`;

/** Dashboard Widget actions (Delete) */
export const DELETE_WIDGET = `${DASHBOARD}/DELETE_WIDGET`;
export const DELETE_WIDGET_RESPONSE = `${DASHBOARD}/DELETE_WIDGET_RESPONSE`;
export const DELETE_WIDGET_ERROR = `${DASHBOARD}/DELETE_WIDGET_ERROR`;

/** Dashboard Widget actions (Save) */
export const SAVE_WIDGET = `${DASHBOARD}/SAVE_WIDGET`;
export const SAVE_WIDGET_RESPONSE = `${DASHBOARD}/SAVE_WIDGET_RESPONSE`;
export const SAVE_WIDGET_ERROR = `${DASHBOARD}/SAVE_WIDGET_ERROR`;
export const LAYOUT_CHANGE = `${DASHBOARD}/LAYOUT_CHANGE`;

/** Dashboard Campaigns Table Widget actions */
export const FETCH_CAMPAIGNS = `${DASHBOARD}/FETCH_CAMPAIGNS`;
export const FETCH_CAMPAIGNS_INIT = `${DASHBOARD}/FETCH_CAMPAIGNS_INIT`;
export const FETCH_CAMPAIGNS_ERROR = `${DASHBOARD}/FETCH_CAMPAIGNS_ERROR`;
export const FETCH_CAMPAIGNS_RESPONSE = `${DASHBOARD}/FETCH_CAMPAIGNS_RESPONSE`;

/** Add/Edit Modal actions */
export const OPEN_ADD_EDIT_MODAL = `${DASHBOARD}/OPEN_ADD_EDIT_MODAL`;
export const CLOSE_ADD_EDIT_MODAL = `${DASHBOARD}/CLOSE_ADD_EDIT_MODAL`;
export const CHANGE_SELECTED_WIDGET = `${DASHBOARD}/CHANGE_SELECTED_WIDGET`;

/** Delete Modal actions */
export const OPEN_DELETE_MODAL = `${DASHBOARD}/OPEN_DELETE_MODAL`;
export const CLOSE_DELETE_MODAL = `${DASHBOARD}/CLOSE_DELETE_MODAL`;

/** Settings Modal actions */
export const OPEN_SETTINGS_MODAL = `${DASHBOARD}/OPEN_SETTINGS_MODAL`;
export const CLOSE_SETTINGS_MODAL = `${DASHBOARD}/CLOSE_SETTINGS_MODAL`;

/** Dashboard settings actions */
export const CHANGE_THEME = `${DASHBOARD}/CHANGE_THEME`;
export const CHANGE_DEFAULT_START_RANGE = `${DASHBOARD}/CHANGE_DEFAULT_START_RANGE`;
export const CHANGE_DEFAULT_END_RANGE = `${DASHBOARD}/CHANGE_DEFAULT_END_RANGE`;

/** Date/Time range actions */
export const CHANGE_START_DATE = `${DASHBOARD}/CHANGE_START_DATE`;
export const CHANGE_END_DATE = `${DASHBOARD}/CHANGE_END_DATE`;
export const CHANGE_START_TIME = `${DASHBOARD}/CHANGE_START_TIME`;
export const CHANGE_END_TIME = `${DASHBOARD}/CHANGE_END_TIME`;

/** Fetching actions */
export const FETCH_DASHBOARD = `${DASHBOARD}/FETCH_DASHBOARD`;
export const FETCH_DASHBOARD_ERROR = `${DASHBOARD}/FETCH_DASHBOARD_ERROR`;
export const FETCH_DASHBOARD_RESPONSE = `${DASHBOARD}/FETCH_DASHBOARD_RESPONSE`;

/** Fetching widget data actions */
export const FETCH_DASHBOARD_DATA = `${DASHBOARD}/FETCH_DASHBOARD_DATA`;
export const FETCH_DASHBOARD_DATA_INIT = `${DASHBOARD}/FETCH_DASHBOARD_DATA_INIT`;
export const FETCH_DASHBOARD_DATA_COMPLETE = `${DASHBOARD}/FETCH_DASHBOARD_DATA_COMPLETE`;
export const FETCH_DASHBOARD_DATA_ERROR = `${DASHBOARD}/FETCH_DASHBOARD_DATA_ERROR`;
export const FETCH_DASHBOARD_DATA_WIDGET_ERROR = `${DASHBOARD}/FETCH_DASHBOARD_DATA_WIDGET_ERROR`;
export const FETCH_DASHBOARD_DATA_RESPONSE = `${DASHBOARD}/FETCH_DASHBOARD_DATA_RESPONSE`;

/** Saving actions */
export const SAVE_DASHBOARD = `${DASHBOARD}/SAVE_DASHBOARD`;
export const SAVE_DASHBOARD_ERROR = `${DASHBOARD}/SAVE_DASHBOARD_ERROR`;
export const SAVE_DASHBOARD_RESPONSE = `${DASHBOARD}/SAVE_DASHBOARD_RESPONSE`;

export const RESET_DASHBOARD = `${DASHBOARD}/RESET_DASHBOARD`;
